import { Context, createContext, ReactNode } from 'react';

export const AppActionsContext = createContext({
  appActions: [],
  setAppActions: actions => {},
});
